import { GenericObject } from "utility/misc";

export default function redirectToOktaConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/sources/okta/connect");
}
